import React, { useState } from "react";
import { Card, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { RoleForm, RoleList } from "./";
import { ManagementLayout, Can } from "@components/shared";
import { PERMISSIONS } from "@util/permissions";

export default function RoleManagement() {
  const [refresh, setRefresh] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <ManagementLayout
      dataComponent={<RoleList refresh={refresh} />}
      createComponent={
        <Can permission={PERMISSIONS.ROLES_CREATE}>
          <Card>
            <Title order={4}>
              {t("create")} {t("role_singular")}
            </Title>
            <RoleForm
              onSuccess={(role) => {
                setRefresh(!refresh);
                if (role?.id) navigate(`/roles/${role.id}`);
              }}
            />
          </Card>
        </Can>
      }
    />
  );
}
